/*
 * Centro de avisos (docs/normcore-centro-avisos.md): campana de la cabecera + panel / hoja, y la página «Avisos» de Mi cuenta.
 * Todo pasa por el gateway (listNotifications, markNotificationsRead); sin features.notifications el gateway contesta `unavailable` y aquí no se pinta nada.
 * Los textos salen de snippets/nc-notices-i18n.liquid (locales nc_notices.*); el tema nunca inventa avisos.
 * aria-live: solo se anuncia lo que cambia por una acción de la persona (marcar leído), nunca en la carga.
 */
(function (root) {
  'use strict';
  var doc = root.document;
  var I18N = null;
  function i18n() {
    if (I18N) return I18N;
    var el = doc.querySelector('[data-nc-notices-i18n]');
    try { I18N = el ? JSON.parse(el.textContent) : null; } catch (e) { I18N = null; }
    return I18N || { t: {}, links: {}, lang: 'es' };
  }
  function tr(key, vars) {
    var s = i18n().t[key] || '';
    Object.keys(vars || {}).forEach(function (k) { s = s.split('{' + k + '}').join(vars[k]); });
    return s;
  }
  function gateway() {
    if (root.NcApp && root.NcApp.gateway) return root.NcApp.gateway();
    return root.NcGatewayTryon && root.NcGatewayTryon.wrap ? root.NcGatewayTryon.wrap({}) : null;
  }
  var gw = null;
  function g() { if (!gw) gw = gateway(); return gw; }

  // texts of the row actions: Spanish defaults here (the locale key budget of this theme is spent, see the look-sheet precedent); the locale wins when the key exists
  var DEFAULTS = {
    act_read: 'Marcar como leído', act_unread: 'Marcar como no leído', act_delete: 'Borrar aviso', swipe_read: 'Leído', swipe_delete: 'Borrar',
    deleted: 'Aviso borrado', undo: 'Deshacer', delete_failed: 'No se pudo borrar el aviso. Vuelve a intentarlo.', restored: 'Aviso recuperado'
  };
  function trd(key) { return tr(key) || DEFAULTS[key] || ''; }
  // what the backend can do beyond "mark as read": delete / mark unread only when /config says so (see docs/normcore-centro-avisos-acciones.md)
  var caps = { del: false, unread: false };
  var SWIPE_W = 88, SWIPE_SNAP = 44, SWIPE_LOCK = 10, UNDO_MS = 6000;
  // pure: what a drag that ends at offset x (px, + = right) means. A full swipe (past 55 % of the row, at least 120 px) runs the action at once;
  // past 44 px the row anchors open on its button (88 px) so the person confirms with a tap; less springs back.
  function swipeOutcome(x, rowW) {
    var a = Math.abs(x);
    if (a >= Math.max(120, (rowW || 0) * 0.55)) return 'commit';
    if (a >= SWIPE_SNAP) return 'anchor';
    return 'close';
  }
  // which action sits on each side of a row: right swipe reveals "read" (only unread rows); left swipe reveals delete, or read when delete is not available yet
  function sideAction(side, row) {
    if (side === 'start') return row.unread ? 'read' : '';
    return row.canDelete ? 'delete' : (row.unread ? 'read' : '');
  }

  var ICONS = {
    look_ready: '<path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/>',
    photo_expiring: '<path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/><path d="M12 7v5l4 2"/>',
    account: '<path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"/><circle cx="12" cy="12" r="3"/>'
  };
  function iconFor(type) { return ICONS[type] || ICONS.account; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function fmtDate(iso) {
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    try { return new Intl.DateTimeFormat(i18n().lang || 'es', { day: 'numeric', month: 'long', year: 'numeric' }).format(d); } catch (e) { return d.toISOString().slice(0, 10); }
  }
  function fmtAbsolute(iso) {
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    try { return new Intl.DateTimeFormat(i18n().lang || 'es', { dateStyle: 'medium', timeStyle: 'short' }).format(d); } catch (e) { return d.toISOString(); }
  }
  function fmtRelative(iso) {
    var ms = Date.now() - new Date(iso).getTime(), min = Math.round(ms / 60000);
    if (isNaN(ms) || min < 1) return tr('now');
    var unit = 'minute', val = -min;
    if (min >= 60 * 24) { unit = 'day'; val = -Math.round(min / (60 * 24)); } else if (min >= 60) { unit = 'hour'; val = -Math.round(min / 60); }
    try { return new Intl.RelativeTimeFormat(i18n().lang || 'es', { numeric: 'auto' }).format(val, unit); } catch (e) { return fmtDate(iso); }
  }

  // one notice -> { title, body, cta, href }. Texts are keyed by type; the payload only fills {hours} / {date}.
  function describe(n) {
    var p = n.payload || {}, type = n.type, known = !!i18n().t[type + '_title'];
    if (!known) return null;
    var date = fmtDate(type === 'deletion_scheduled' ? p.executeAfter : p.at || n.createdAt);
    var vars = { hours: p.hours || 24, date: date };
    var href = (i18n().links || {})[type] || '';
    var cta = i18n().t[type + '_cta'] ? tr(type + '_cta') : '';
    if (type === 'look_ready' && p.renderId && href) href += (href.indexOf('?') < 0 ? '?' : '&') + 'look=' + encodeURIComponent(p.renderId);
    return { title: tr(type + '_title', vars), body: tr(type + '_body', vars), cta: href ? cta : '', href: href };
  }

  // the button a swipe uncovers: a real button (tap to confirm), hidden from keyboard and screen readers because the row already has its own visible buttons
  function swipeBtn(side, act, id) {
    if (!act) return '';
    return '<button type="button" class="nc-notice__swipe nc-notice__swipe--' + side + ' nc-notice__swipe--' + act + '" data-nc-act="' + act + '" data-nc-id="' + esc(id) + '" tabindex="-1" aria-hidden="true">' + esc(trd(act === 'delete' ? 'swipe_delete' : 'swipe_read')) + '</button>';
  }
  function itemHtml(n) {
    var d = describe(n);
    if (!d) return '';
    var unread = !n.read;
    var inner = '<span class="nc-notice__icon" aria-hidden="true"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" focusable="false">' + iconFor(n.type) + '</svg></span>'
      + '<span class="nc-notice__text"><span class="nc-notice__title">' + esc(d.title) + '</span><span class="nc-notice__body">' + esc(d.body) + '</span>'
      + '<span class="nc-notice__meta"><time datetime="' + esc(n.createdAt) + '" title="' + esc(fmtAbsolute(n.createdAt)) + '">' + esc(fmtRelative(n.createdAt)) + '</time>' + (d.cta ? '<span class="nc-notice__cta">' + esc(d.cta) + '</span>' : '') + '</span></span>'
      + (unread ? '<span class="nc-notice__dot" aria-hidden="true"></span><span class="nc-visually-hidden">' + esc(tr('unread_hidden')) + '</span>' : '');
    var cls = 'nc-notice' + (unread ? ' nc-notice--unread' : '');
    var open = d.href ? '<a class="nc-notice__link nc-focusable" href="' + esc(d.href) + '" data-nc-notice="' + esc(n.id) + '">' : '<button type="button" class="nc-notice__link nc-focusable" data-nc-notice="' + esc(n.id) + '"' + (unread ? '' : ' aria-disabled="true" tabindex="-1"') + '>';
    var ICON_CHECK = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M20 6 9 17l-5-5"/></svg>';
    var ICON_TRASH = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6M10 11v6M14 11v6"/></svg>';
    var acts = (unread ? '<button type="button" class="nc-notice__act nc-focusable" data-nc-act="read" data-nc-id="' + esc(n.id) + '" aria-label="' + esc(trd('act_read')) + '">' + ICON_CHECK + '</button>' : '')
      + (caps.del ? '<button type="button" class="nc-notice__act nc-notice__act--delete nc-focusable" data-nc-act="delete" data-nc-id="' + esc(n.id) + '" aria-label="' + esc(trd('act_delete')) + '">' + ICON_TRASH + '</button>' : '');
    return '<li class="' + cls + '" data-nc-row="' + esc(n.id) + '" data-nc-unread="' + (unread ? '1' : '0') + '">'
      + swipeBtn('start', sideAction('start', { unread: unread, canDelete: caps.del }), n.id)
      + swipeBtn('end', sideAction('end', { unread: unread, canDelete: caps.del }), n.id)
      + '<div class="nc-notice__row">' + open + inner + (d.href ? '</a>' : '</button>') + (acts ? '<div class="nc-notice__actions">' + acts + '</div>' : '') + '</div></li>';
  }
  function listHtml(list) { return '<ul class="nc-notices-list" role="list">' + list.map(itemHtml).join('') + '</ul>'; }
  function stateHtml(kind, retry) {
    if (kind === 'loading') return '<div class="nc-notices-state nc-notices-state--loading" role="status"><span class="nc-notices-skeleton"></span><span class="nc-notices-skeleton"></span><span class="nc-notices-skeleton"></span><span class="nc-visually-hidden">' + esc(tr('loading')) + '</span></div>';
    if (kind === 'error') return '<div class="nc-notices-state" role="alert"><p class="nc-notices-state__title">' + esc(tr('error_title')) + '</p><button type="button" class="nc-notices-btn nc-focusable" data-nc-retry>' + esc(tr('error_retry')) + '</button></div>';
    if (kind === 'unavailable') return '<div class="nc-notices-state"><p class="nc-notices-state__text">' + esc(tr('unavailable_text')) + '</p></div>';
    return '<div class="nc-notices-state"><p class="nc-notices-state__title">' + esc(tr('empty_title')) + '</p><p class="nc-notices-state__text">' + esc(tr('empty_text')) + '</p><a class="nc-notices-btn nc-notices-btn--primary nc-focusable" href="' + esc(i18n().tryOnUrl || '#') + '">' + esc(tr('empty_cta')) + '</a></div>';
  }

  // shared data holder: both elements read the same list and tell each other when it changes
  var store = { list: [], unread: 0, available: null, loading: false, error: false };
  var inflight = null;
  function load() {
    var gate = g();
    if (!gate || !gate.listNotifications) { store.available = false; return Promise.resolve(store); }
    if (inflight) return inflight; // the bell and the page share one request
    store.loading = true; store.error = false;
    inflight = gate.listNotifications().then(function (r) {
      store.available = !(r && r.unavailable);
      store.list = (r && r.notifications) || [];
      store.unread = (r && r.unread) || 0;
      store.loading = false;
      return store;
    }, function () {
      store.loading = false; store.error = true; if (store.available === null) store.available = false;
      return store;
    }).then(function (s) { inflight = null; doc.dispatchEvent(new CustomEvent('nc-notices:change')); return s; });
    return inflight;
  }
  function markRead(input) {
    var gate = g();
    if (!gate || !gate.markNotificationsRead) return Promise.resolve();
    var ids = input.all ? null : input.ids || [];
    store.list.forEach(function (n) { if (!ids || ids.indexOf(n.id) >= 0) n.read = true; });
    store.unread = store.list.filter(function (n) { return !n.read; }).length;
    doc.dispatchEvent(new CustomEvent('nc-notices:change', { detail: { byPerson: true } }));
    return gate.markNotificationsRead(input).then(function (r) { if (r && typeof r.unread === 'number') store.unread = r.unread; }, function () { return load(); });
  }
  // the nav item of the profile sidebar and the page link appear only when the feature answers
  function revealNav() { Array.prototype.forEach.call(doc.querySelectorAll('[data-nc-notices-nav]'), function (el) { el.hidden = !store.available; }); }

  // ---- toast for new notices (Javi, 2026-10-30: a notice that arrives must also show as a toaster, not only as the bell counter)
  // "New" = unread and created after the last one already toasted on this device (localStorage, per customer); the first time only the last 10 minutes count,
  // so old unread notices never flood a first visit. Checked on load, when the tab comes back and every 60 s while it is visible (one light GET).
  var TOAST_POLL_MS = 60000, TOAST_FIRST_WINDOW_MS = 10 * 60000, TOAST_MAX = 2;
  function seenKey() { return 'nc-notices-seen:' + (doc.body && doc.body.getAttribute('data-nc-customer-id') || 'me'); }
  function readSeen() { try { var v = root.localStorage.getItem(seenKey()); return v ? Date.parse(v) : null; } catch (e) { return null; } }
  function writeSeen(ms) { try { root.localStorage.setItem(seenKey(), new Date(ms).toISOString()); } catch (e) { /* private mode: the toast may repeat on the next page */ } }
  function newNotices() {
    var seen = readSeen();
    if (seen === null) seen = Date.now() - TOAST_FIRST_WINDOW_MS;
    return store.list.filter(function (n) { return !n.read && Date.parse(n.createdAt) > seen && describe(n); }).sort(function (a, b) { return Date.parse(a.createdAt) - Date.parse(b.createdAt); });
  }
  function toastNew() {
    if (!root.NcToast || !root.NcToast.show || store.available !== true || doc.querySelector('nc-notices-page')) return;
    var fresh = newNotices();
    if (!fresh.length) return;
    writeSeen(Date.parse(fresh[fresh.length - 1].createdAt));
    var viewAll = i18n().noticesUrl || '';
    var shown = fresh.length <= TOAST_MAX ? fresh : null;
    if (shown) shown.forEach(function (n) {
      var d = describe(n);
      var t = root.NcToast.show({ tone: 'success', message: d.title, detail: d.body, actionLabel: d.href ? d.cta || tr('toast_open') : '', actionId: 'open', duration: 8000 });
      if (t && d.href) t.addEventListener('nc-toast:action', function () { markRead({ ids: [n.id] }).then(function () { root.location.href = d.href; }, function () { root.location.href = d.href; }); });
    });
    else {
      var t = root.NcToast.show({ tone: 'success', message: tr('toast_many', { n: fresh.length }), actionLabel: viewAll ? tr('toast_view_all') : '', actionId: 'open', duration: 8000 });
      if (t && viewAll) t.addEventListener('nc-toast:action', function () { root.location.href = viewAll; });
    }
  }
  var polling = null;
  function refreshSilently() {
    var gate = g();
    if (!gate || !gate.listNotifications || store.available !== true || doc.visibilityState === 'hidden' || inflight) return Promise.resolve();
    return gate.listNotifications().then(function (r) {
      if (r && r.unavailable) return;
      store.list = (r && r.notifications) || store.list; store.unread = (r && r.unread) || 0; store.error = false;
      doc.dispatchEvent(new CustomEvent('nc-notices:change'));
      toastNew();
    }, function () { /* a failed poll is silent: the bell keeps the last list */ });
  }
  function startToasts() {
    if (polling) return;
    toastNew();
    polling = root.setInterval(refreshSilently, TOAST_POLL_MS);
    doc.addEventListener('visibilitychange', function () { if (doc.visibilityState === 'visible') refreshSilently(); });
  }

  function ready(fn) { if (doc.readyState === 'complete') fn(); else root.addEventListener('load', fn); }

  // ---- row actions (read / delete with undo) and the swipe gesture shared by the panel and the page
  var pending = {}; // id -> { timer, item, index }
  function announce(msg) { Array.prototype.forEach.call(doc.querySelectorAll('[data-nc-live], [data-nc-page-live]'), function (el) { el.textContent = msg; }); }
  function commitDelete(id) {
    var p = pending[id], gate = g();
    if (!p) return Promise.resolve();
    clearTimeout(p.timer); delete pending[id];
    if (!gate || !gate.deleteNotifications) return Promise.resolve();
    return gate.deleteNotifications({ ids: [id] }).then(null, function () {
      // the server said no: the notice comes back where it was and the person is told
      restore(p, id);
      if (root.NcToast) root.NcToast.show({ tone: 'error', message: trd('delete_failed') });
    });
  }
  function restore(p, id) {
    if (store.list.some(function (n) { return n.id === id; })) return;
    store.list.splice(Math.min(p.index, store.list.length), 0, p.item);
    store.unread = store.list.filter(function (n) { return !n.read; }).length;
    doc.dispatchEvent(new CustomEvent('nc-notices:change', { detail: { byPerson: true } }));
  }
  function deleteNotice(id) {
    if (!caps.del || pending[id]) return;
    var index = -1;
    store.list.forEach(function (n, i) { if (n.id === id) index = i; });
    if (index < 0) return;
    var item = store.list.splice(index, 1)[0];
    store.unread = store.list.filter(function (n) { return !n.read; }).length;
    var p = pending[id] = { item: item, index: index, timer: setTimeout(function () { commitDelete(id); }, UNDO_MS + 300) };
    doc.dispatchEvent(new CustomEvent('nc-notices:change', { detail: { byPerson: true } }));
    announce(trd('deleted'));
    if (root.NcToast) {
      var t = root.NcToast.show({ tone: 'success', message: trd('deleted'), actionLabel: trd('undo'), actionId: 'undo', duration: UNDO_MS });
      if (t) t.addEventListener('nc-toast:action', function () { if (!pending[id]) return; clearTimeout(p.timer); delete pending[id]; restore(p, id); announce(trd('restored')); });
    }
  }
  // closing or leaving the page must not lose a delete the person already confirmed by not undoing it
  root.addEventListener('pagehide', function () { Object.keys(pending).forEach(commitDelete); });
  function rowAction(act, id) {
    if (act === 'read') markRead({ ids: [id] });
    else if (act === 'delete') deleteNotice(id);
  }
  // click on a row button; returns true when it handled the click
  function onActClick(e) {
    var b = e.target.closest('[data-nc-act]');
    if (!b) return false;
    e.preventDefault();
    var row = b.closest('[data-nc-row]');
    var next = row && (row.nextElementSibling || row.previousElementSibling);
    rowAction(b.getAttribute('data-nc-act'), b.getAttribute('data-nc-id'));
    // the focused button disappears with its row: focus moves to the neighbour, or to the list host
    var target = next && next.querySelector('.nc-notice__link');
    if (target && target.isConnected) target.focus();
    return true;
  }
  // Delete on a focused notice removes it (when the backend allows it)
  function onRowKey(e) {
    if (e.key !== 'Delete' || !caps.del) return;
    var row = e.target.closest && e.target.closest('[data-nc-row]');
    if (!row) return;
    e.preventDefault();
    var next = row.nextElementSibling || row.previousElementSibling;
    deleteNotice(row.getAttribute('data-nc-row'));
    var target = next && next.querySelector('.nc-notice__link');
    if (target && target.isConnected) target.focus();
  }
  // swipe on touch / pen. Right reveals "read", left reveals delete (or read while delete is off). Release past 44 px anchors the row open on its button
  // (tap to confirm, tap anywhere else or swipe back to close); a full swipe runs the action at once. Vertical scroll stays native (touch-action: pan-y).
  var anchored = null; // { li, row, x }
  function reducedMotion() { return !!(root.matchMedia && root.matchMedia('(prefers-reduced-motion: reduce)').matches); }
  function setX(row, x, animate) {
    row.style.transition = animate && !reducedMotion() ? 'transform 180ms ease-out' : 'none';
    row.style.transform = x ? 'translateX(' + Math.round(x) + 'px)' : '';
  }
  function closeAnchor() {
    if (!anchored) return;
    var a = anchored; anchored = null;
    if (a.row.isConnected) { setX(a.row, 0, true); a.li.removeAttribute('data-open'); }
  }
  function bindSwipe(host) {
    var st = null;
    host.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' || !e.isPrimary || e.target.closest('[data-nc-act]')) return;
      var li = e.target.closest('[data-nc-row]');
      if (anchored && (!li || anchored.li !== li)) closeAnchor();
      if (!li) return;
      var base = anchored && anchored.li === li ? anchored.x : 0;
      st = { li: li, row: li.querySelector('.nc-notice__row'), id: e.pointerId, x: e.clientX, y: e.clientY, base: base, cur: base, locked: false, rowW: li.getBoundingClientRect().width };
    });
    host.addEventListener('pointermove', function (e) {
      if (!st || e.pointerId !== st.id) return;
      var dx = e.clientX - st.x, dy = e.clientY - st.y;
      if (!st.locked) {
        if (Math.hypot(dx, dy) < SWIPE_LOCK) return;
        if (Math.abs(dy) >= Math.abs(dx)) { st = null; return; } // a vertical gesture: the list scrolls
        st.locked = true;
        try { st.li.setPointerCapture(st.id); } catch (err) { /* pointer already gone */ }
      }
      var row = { unread: st.li.getAttribute('data-nc-unread') === '1', canDelete: caps.del };
      var x = st.base + dx;
      // a side with no action is a wall: it gives a little (rubber band) and never promises anything
      if (x > 0 && !sideAction('start', row)) x = x * 0.15;
      if (x < 0 && !sideAction('end', row)) x = x * 0.15;
      st.cur = Math.max(-st.rowW, Math.min(st.rowW, x));
      st.li.setAttribute('data-open', st.cur > 0 ? 'start' : 'end');
      setX(st.row, st.cur, false);
    });
    var end = function (e) {
      if (!st || e.pointerId !== st.id) return;
      var cur = st; st = null;
      if (!cur.locked) return;
      cur.li.setAttribute('data-swiped', '');
      setTimeout(function () { cur.li.removeAttribute('data-swiped'); }, 400); // the click that follows a drag must not open the notice
      var row = { unread: cur.li.getAttribute('data-nc-unread') === '1', canDelete: caps.del };
      var side = cur.cur > 0 ? 'start' : 'end', act = sideAction(side, row);
      var outcome = e.type === 'pointerup' && act ? swipeOutcome(cur.cur, cur.rowW) : 'close';
      if (outcome === 'commit') {
        anchored = null;
        setX(cur.row, side === 'start' ? cur.rowW : -cur.rowW, true);
        setTimeout(function () { rowAction(act, cur.li.getAttribute('data-nc-row')); }, reducedMotion() ? 0 : 180);
      } else if (outcome === 'anchor') {
        anchored = { li: cur.li, row: cur.row, x: side === 'start' ? SWIPE_W : -SWIPE_W };
        setX(cur.row, anchored.x, true);
      } else {
        if (anchored && anchored.li === cur.li) anchored = null;
        setX(cur.row, 0, true);
        cur.li.removeAttribute('data-open');
      }
    };
    host.addEventListener('pointerup', end); host.addEventListener('pointercancel', end);
    // a drag, or the tap that closes an anchored row, must not follow the link
    host.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-nc-act]')) return; // the button a swipe uncovered is the confirmation
      var li = e.target.closest && e.target.closest('[data-swiped]');
      if (li) { e.preventDefault(); e.stopPropagation(); return; }
      if (anchored && e.target.closest('.nc-notice__row') && anchored.li.contains(e.target)) { e.preventDefault(); e.stopPropagation(); closeAnchor(); }
    }, true);
    host.addEventListener('keydown', function (e) { if (e.key === 'Escape' && anchored) closeAnchor(); onRowKey(e); });
    host.addEventListener('scroll', closeAnchor, true);
  }
  function loadCaps() {
    var gate = g();
    if (!gate || !gate.noticeActions) return Promise.resolve();
    return gate.noticeActions().then(function (c) { caps.del = !!(c && c.del); caps.unread = !!(c && c.unread); doc.dispatchEvent(new CustomEvent('nc-notices:change')); }, function () { /* no extra actions */ });
  }

  // ---- bell + panel
  var Bell = class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.btn = this.querySelector('[data-nc-bell]'); this.count = this.querySelector('[data-nc-bell-count]');
      this.panel = this.querySelector('[data-nc-panel]'); this.body = this.querySelector('[data-nc-body]');
      this.backdrop = this.querySelector('[data-nc-bell-backdrop]'); this.live = this.querySelector('[data-nc-live]');
      this.markAll = this.querySelector('[data-nc-mark-all]'); this.viewAll = this.querySelector('[data-nc-view-all]');
      if (this.viewAll && i18n().noticesUrl) this.viewAll.setAttribute('href', i18n().noticesUrl);
      this.btn.addEventListener('click', function () { self.isOpen() ? self.close(true) : self.open(); });
      this.querySelector('[data-nc-close]').addEventListener('click', function () { self.close(true); });
      this.backdrop.addEventListener('click', function () { self.close(true); });
      this.markAll.addEventListener('click', function () { markRead({ all: true }); });
      bindSwipe(this.panel);
      this.panel.addEventListener('click', function (e) {
        if (onActClick(e)) return;
        if (e.target.closest('[data-nc-retry]')) { self.show(); load(); return; }
        var item = e.target.closest('[data-nc-notice]');
        if (item && !item.getAttribute('aria-disabled')) markRead({ ids: [item.getAttribute('data-nc-notice')] });
      });
      // Escape closes and returns focus to the bell; in the bottom sheet Tab stays inside it (the sheet sits on a backdrop)
      var onKey = function (e) {
        if (!self.isOpen()) return;
        if (e.key === 'Escape') { e.stopPropagation(); self.close(true); return; }
        if (e.key !== 'Tab' || !self.sheet) return;
        var f = Array.prototype.filter.call(self.panel.querySelectorAll('a[href], button:not([hidden]):not([aria-disabled="true"])'), function (el) { return !el.hidden && el.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); } else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
      };
      this.addEventListener('keydown', onKey); this.panel.addEventListener('keydown', onKey);
      this.bindDrag();
      doc.addEventListener('click', function (e) { if (self.isOpen() && !self.contains(e.target) && !self.panel.contains(e.target) && !self.backdrop.contains(e.target)) self.close(false); });
      doc.addEventListener('nc-notices:change', function (e) { self.update(e.detail && e.detail.byPerson); });
      ready(function () { load().then(function () { revealNav(); if (store.available === true) { loadCaps(); startToasts(); } }); });
    }
    isOpen() { return !this.panel.hidden; }
    // bottom sheet only: dragging the title bar down (touch / pen, past 80 px or a quick flick) closes it; the close button stays the visible alternative
    bindDrag() {
      var self = this, head = this.panel.querySelector('.nc-notices-panel__head'), startY = 0, startT = 0, dy = 0, pid = null, dragging = false;
      if (!head) return;
      head.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' || !e.isPrimary || !self.sheet || e.target.closest('button')) return;
        pid = e.pointerId; startY = e.clientY; startT = e.timeStamp; dy = 0; dragging = false;
      });
      head.addEventListener('pointermove', function (e) {
        if (pid === null || e.pointerId !== pid) return;
        dy = e.clientY - startY;
        if (!dragging) { if (dy < 6) return; dragging = true; self.panel.style.transition = 'none'; try { head.setPointerCapture(pid); } catch (err) { /* pointer gone */ } }
        self.panel.style.transform = 'translateY(' + Math.max(dy, 0) + 'px)';
      });
      var end = function (e) {
        if (pid === null || e.pointerId !== pid) return;
        var was = dragging; pid = null; dragging = false;
        if (!was) return;
        var reduced = root.matchMedia && root.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var dismiss = e.type === 'pointerup' && (dy > 80 || (dy > 24 && dy / Math.max(e.timeStamp - startT, 1) > 0.5));
        self.panel.style.transition = reduced ? 'none' : 'transform 180ms ease-out';
        self.panel.style.transform = dismiss ? 'translateY(100%)' : '';
        if (dismiss) setTimeout(function () { self.close(true); }, reduced ? 0 : 180);
      };
      head.addEventListener('pointerup', end); head.addEventListener('pointercancel', end);
    }
    // a sticky header creates a containing block (transform), so under 750 px the sheet and its backdrop live in <body> while open: position: fixed then means the viewport
    mount() {
      this.sheet = !!(root.matchMedia && root.matchMedia('(max-width: 749.98px)').matches);
      var host = this.sheet ? doc.body : this;
      if (this.panel.parentNode !== host) { host.appendChild(this.backdrop); host.appendChild(this.panel); }
      if (this.sheet) this.panel.setAttribute('aria-modal', 'true'); else this.panel.removeAttribute('aria-modal');
    }
    open() {
      this.mount();
      this.panel.hidden = false; this.backdrop.hidden = false; this.btn.setAttribute('aria-expanded', 'true');
      // as a bottom sheet the page behind must not scroll (same lock as nc-sheet / nc-look-sheet)
      if (this.sheet) doc.documentElement.setAttribute('data-nc-scroll-lock', '');
      this.panel.style.transform = ''; this.panel.style.transition = '';
      this.show();
      var first = this.panel.querySelector('a, button:not([aria-disabled])');
      (first || this.panel).focus && (first || this.panel).focus();
    }
    close(restoreFocus) {
      this.panel.hidden = true; this.backdrop.hidden = true; this.btn.setAttribute('aria-expanded', 'false');
      doc.documentElement.removeAttribute('data-nc-scroll-lock');
      this.panel.style.transform = ''; this.panel.style.transition = '';
      if (restoreFocus) this.btn.focus();
    }
    show() {
      if (store.loading) this.body.innerHTML = stateHtml('loading');
      else if (store.error) this.body.innerHTML = stateHtml('error');
      else if (!store.list.length) this.body.innerHTML = stateHtml('empty');
      else this.body.innerHTML = listHtml(store.list.slice(0, 8));
      this.markAll.hidden = !(store.unread > 0 && store.list.length);
      this.viewAll.hidden = !store.list.length;
    }
    update(byPerson) {
      var on = store.available === true;
      this.hidden = !on;
      if (!on) { if (this.isOpen()) this.close(false); return; }
      var n = store.unread;
      this.count.hidden = n < 1; this.count.textContent = n > 9 ? '9+' : String(n);
      this.btn.setAttribute('aria-label', n > 0 ? tr('bell_unread', { n: n }) : tr('bell'));
      if (this.isOpen()) this.show();
      if (byPerson) this.live.textContent = n > 0 ? tr('unread_count', { n: n }) : tr('all_read');
    }
  };
  if (!root.customElements.get('nc-notices-bell')) root.customElements.define('nc-notices-bell', Bell);

  // ---- page "Avisos"
  var Page = class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.body = this.querySelector('[data-nc-page-body]'); this.markAll = this.querySelector('[data-nc-page-mark]'); this.live = this.querySelector('[data-nc-page-live]');
      this.markAll.addEventListener('click', function () { markRead({ all: true }); });
      bindSwipe(this);
      this.addEventListener('click', function (e) {
        if (onActClick(e)) return;
        if (e.target.closest('[data-nc-retry]')) { self.render(); load(); return; }
        var item = e.target.closest('[data-nc-notice]');
        if (item && !item.getAttribute('aria-disabled')) markRead({ ids: [item.getAttribute('data-nc-notice')] });
      });
      doc.addEventListener('nc-notices:change', function (e) { self.render(e.detail && e.detail.byPerson); });
      this.render();
      ready(function () { load().then(function () { revealNav(); if (store.available === true) loadCaps(); }); });
    }
    render(byPerson) {
      if (store.available === null && !store.error) this.body.innerHTML = stateHtml('loading');
      else if (store.error) this.body.innerHTML = stateHtml('error');
      else if (store.available === false) this.body.innerHTML = stateHtml('unavailable');
      else if (!store.list.length) this.body.innerHTML = stateHtml('empty');
      else this.body.innerHTML = listHtml(store.list);
      this.markAll.hidden = !(store.available && store.unread > 0);
      this.body.setAttribute('aria-busy', store.loading ? 'true' : 'false');
      if (byPerson) this.live.textContent = store.unread > 0 ? tr('unread_count', { n: store.unread }) : tr('all_read');
    }
  };
  if (!root.customElements.get('nc-notices-page')) root.customElements.define('nc-notices-page', Page);

  root.NcNotices = { describe: describe, load: load, state: store, newNotices: newNotices, swipeOutcome: swipeOutcome, sideAction: sideAction };
})(typeof window !== 'undefined' ? window : globalThis);
